import { capitalize, isAdult } from 'utils';
import { defaultPhotoID } from '../types';


const keyMapper = {
    occupants: {
        full_name: 'name',
        home_phone: 'homePhone',
        work_phone: 'workPhone',
        cell_phone: 'cellPhone',
        phone: 'phoneNumber',
    },
    move_in: {
        expected_move_in: 'moveInDate',
        floor_plan_id: 'selectedFloorPlan',
        unit_number: 'selectedUnitNumber',
    },
    vehicles: {
        make_model: 'modal',
        license_plate: 'licensePlate',
    },
    emergency_contacts: {
        phone: 'phoneNumber'
    },
    histories: {
        landlord_name: 'name',
        landlord_phone: 'number',
        landlord_email: 'email',
        current: 'current',
    },
    employments: {
        employer: 'employerName',
        phone: 'phoneNumber',
        supervisor: 'supervisorName',
        salary: 'monthlyIncome',
        duration: 'durationOfEmployment',
    },
}

const setterMap = {
    move_in: 'moveInInformation',
    emergency_contacts: 'emergencyContacts',
    histories: 'currentResidency',
    employments: 'employmentInformations'
}

const statusMap = {
    'Lease Holder': 'leaseholder',
    'Occupant': 'occupant',
}

export const serverToClientMapper = (form, manager) => {

    const adultOccupants = form.occupants.filter((person) => isAdult(person.dob));
    const updatedphotoIDs = adultOccupants.map(adult => {
        return { ...defaultPhotoID, type: `photoID-${adult.id}`, id: `photoID-${adult.id}`, docIDError: "Please upload photo ID", hasError: true }})
    manager.setPhotoIDs(updatedphotoIDs)

    for (let section in form) {
        const keysToExclude = [
            'lang',
            'saved_form_id',
            'start_time',
            'terms_and_conditions',
            'last_active_screen',
            'income'
        ]

        if (keysToExclude.includes(section)) continue;


        let sectionState = form[section]
        if (section === 'histories') {
            sectionState = sectionState[0]
        }


        if (section === 'employments') { 
            sectionState[0].extra_income = sectionState[0].extra_income || form?.income?.salary || ''
            sectionState[0].extra_income_description = sectionState[0].extra_income_description || form?.income?.description || ''
        }

        if (Array.isArray(sectionState)) {
            const dataArray = []
            sectionState.forEach((resource) => {
                const dataObj = {};
                for (let [key, value] of Object.entries(resource)) {
                    if( key == 'otherIncome') {
                        for (let [incomeKey, incomeValue] of Object.entries(value)) dataObj[incomeKey] = incomeValue
                        continue;
                     }

                    const sectionMap = keyMapper[section]
                    dataObj[sectionMap?.[key] || key] = statusMap?.[value] || value;
                }
                dataArray.push(dataObj)
            })


            const setterName = 'set' + capitalize(setterMap[section] || section)
            manager[setterName](dataArray)
        } else {
            const dataObj = {};
            for (let [key, value] of Object.entries(sectionState)) {
                dataObj[keyMapper?.[section]?.[key] || key] = value;
            }

            const setterName = 'set' + capitalize(setterMap[section] || section);
            manager[setterName](dataObj)
        }


        switch (section) {
            case 'pets':
                if (sectionState.length > 0) manager.setHavePets(true)
                break;

            case 'vehicles':
                if (sectionState.length > 0) manager.setHaveVehicle(true)
                break;
        }

    }
}
